<template>
    <div class="main-body">
        <cabecalho-padrao/>
        <section class="main">
            <div class="quadro -menor">
                <div class="main-grafico">
                    <div>
                        <h2>{{ graficoMesAnterior.NomeMes }}</h2>
                    </div>                           
                    <button @click="mudarMes(graficoMesAnterior.data)" class="btn-grafico"><canvas ref="graficoAnterior" width="300" height="200"></canvas></button>
                </div>        
            </div>            
            <div class="quadro">
                
                <div class="main-grafico" ref="quadroAtual">
                
                    <div>
                        <h2>{{ graficoMesAtual.NomeMes }}</h2>
                    </div>   
                    <div class="wrapper-grafico">   
                        <button @click="mudarMes(graficoMesAnterior.data)"><img src="..\assets\left-chevron.png"></button>              
                        <div class="grafico">                            
                            <canvas v-if="mostrarGraficoValores=='G' || mostrarGraficoValores==''" ref="graficoAtual"  :width="tamQuadroAtual.width" :height="tamQuadroAtual.height"></canvas>
                            <div class="legendas" v-if="mostrarGraficoValores=='L' || mostrarGraficoValores==''">
                                <div class="linha -verde">
                                    <h3>Receitas</h3>
                                    <h3>R${{formatarValor(graficoMesAtual.VlReceita)}}</h3>
                                </div>
                                <div class="linha -azul">
                                    <h3>Saldo Mês</h3>
                                    <h3>R${{formatarValor(graficoMesAtual.VlSaldo)}}</h3>
                                </div>                                   
                                <div class="linha -vermelho">
                                    <h3>Gastos</h3>
                                    <h3>Fim do Mês</h3>
                                    <h3>R${{formatarValor(graficoMesAtual.VlGastoFim)}}</h3>
                                </div>   
                                <div class="linha">
                                    <h3>Gastos</h3>                                
                                    <h3>Inicio do Mês</h3>
                                    <h3>R${{formatarValor(graficoMesAtual.VlGastoInicio)}}</h3>
                                </div>                                                         
                            </div>
                        </div>
                        <button @click="mudarMes(graficoMesProximo.data)"><img src="..\assets\right-chevron.png"></button>
                    </div>
                    <div class="grafico-bottom">
                            <button @click="MudarGraficoValores('G')"><img src="..\assets\graph.png"></button>
                            <button @click="MudarGraficoValores('L')"><img src="..\assets\dollar.png"></button>
                    </div>                    
                </div>
            
            </div>
            <div class="quadro -menor">
                <div class="main-grafico">
                    <div>
                        <h2>{{ graficoMesProximo.NomeMes }}</h2>
                    </div>                    
                    <button @click="mudarMes(graficoMesProximo.data)" class="btn-grafico"><canvas ref="graficoProximo" width="300" height="200"></canvas></button>        
                </div>                  
            </div>                
        </section>

        <section class="main-destaque">
            <div class="quadro">
                <div class="titulo -verde">                     
                    <h1>R$ {{ ReceberValor }}</h1>   
                    <h2>Receber</h2>             
                </div>               
                <div class="documentos" v-for="item in Receberlista" :key="item.id">
                    <span class="linha">
                        <h2>{{item.Data_vencimento}}</h2>
                        <h2>R${{formatarValor(item.Valor_aberto)}}</h2>
                    </span>
                    <h3>{{item.Nome_cliente}}</h3>             
                    <h3>{{item.Historico}}</h3>              
                </div>
            </div>
            <div class="quadro">
                <div class="titulo -vermelho">                     
                    <h1>R$ {{ PagarValor }}</h1>   
                    <h2>Pagar</h2>             
                </div>               
                <div class="documentos" v-for="item in Pagarlista" :key="item.id">
                    <span class="linha">
                        <h2>{{item.Data_vencimento}}</h2>
                        <h2>R${{formatarValor(item.Valor_aberto)}}</h2>
                    </span>
                    <h3>{{item.Nome_fornecedor}}</h3>             
                    <h3>{{item.Historico}}</h3>              
                </div>                                                                              
            </div>
            <div class="quadro">
                <div class="titulo -azul">                     
                    <h1>R$ {{ CaixaValor }}</h1>   
                    <h2>Em conta</h2>             
                </div>  
                <div class="documentos" v-for="item in Caixalista" :key="item.id">
                    <span class="linha">
                        <h2>{{item.Nome_carteira}}</h2>
                        <h2>R${{formatarValor(item.saldo)}}</h2>
                    </span>
                    <h3>{{item.descricao}}</h3>                          
                </div>                
            </div>                              
        </section>

        <section class="main-menu-mobile">
            <h1>O que deseja fazer?</h1>
            <ul class="botoes">
                  <li><router-link to="/receitas/cadastro" class="botao">Consultar Receitas</router-link></li>
                  <li><router-link to="/gastos/cadastro" class="botao">Consultar Gastos</router-link></li>
                  <li><router-link to="/caixa/cadastro" class="botao">Ver Saldo</router-link></li>
                  <li><router-link to="/mais" class="botao">Mais +</router-link></li>
              </ul>
        </section>

    </div>
</template>

<script>
import api from '../services/api.js';
import CabecalhoPadrao from '../components/Cabecalho.vue';

export default {
  name: 'Home',
  components:{
    'cabecalho-padrao': CabecalhoPadrao
  },
  data: () => ({
    ReceberValor : 0,
    Receberlista: [],
    PagarValor: 0,
    Pagarlista:[],
    CaixaValor: 0,
    Caixalista:[],
    mostrarGraficoValores:'G',
    tamQuadroAtual:{
        width:500,
        height:350
    },
    graficoMesAnterior:{
        data: 0,
        NomeMes:'',
        VlReceita: 0,
        VlGastoInicio: 0,
        VlGastoFim: 0,
        VlSaldo: 0
    },    
    graficoMesAtual:{
        data: 0,
        NomeMes:'',
        VlReceita: 0,
        VlGastoInicio: 0,
        VlGastoFim: 0,
        VlSaldo: 0
    },
    graficoMesProximo:{
        data: 0,
        NomeMes:'',
        VlReceita: 0,
        VlGastoInicio: 0,
        VlGastoFim: 0,
        VlSaldo: 0
    }    

  }),
  methods:{
        calcPosEscalaY(dadosGrafico,yMax,maiorValor,Valor){

            let coeficienteY = 0;
            if (dadosGrafico.VlSaldo<0)
                coeficienteY =  (yMax-40)/(maiorValor+(dadosGrafico.VlSaldo*-1));
            else
                coeficienteY =  (yMax-40)/maiorValor;


            let posEscala = 0;
            if (dadosGrafico.VlSaldo<0)
                posEscala =  (yMax-Math.trunc(coeficienteY*((Valor)+(dadosGrafico.VlSaldo*-1))))-20
            else
                posEscala =  (yMax-Math.trunc(coeficienteY*((Valor))))-20;

            return posEscala;

        },
        async DesenhaGrafico(dadosGrafico,cvn,menor){
            
          let ctx = cvn.getContext("2d");   
          ctx.clearRect(0, 0, cvn.width, cvn.height);         

          let xMin = 0;
          let yMin = 0;
          let xMax = (cvn.width-30); //340
          let yMax = (cvn.height-10);

          let maiorValor = dadosGrafico.VlReceita;
          if (dadosGrafico.VlGastoFim>dadosGrafico.VlReceita)
            maiorValor =  dadosGrafico.VlGastoFim;

          let mod = maiorValor % 1000;

          maiorValor = (maiorValor - mod);
          maiorValor = maiorValor+(maiorValor*0.1);

         

          ctx.beginPath();
          //eixo y
          ctx.moveTo(60, yMax);
          ctx.lineTo(60, 20);



          ctx.font = "12px Arial";
          ctx.textAlign = "end";

          let posEscala = 0;
        

          posEscala = this.calcPosEscalaY(dadosGrafico,yMax,maiorValor,maiorValor*0.1);
          ctx.fillText(this.formatarValor(Math.trunc(maiorValor*0.1)),53,posEscala);    
          ctx.moveTo(55, posEscala);
          ctx.lineTo(65, posEscala);

          if (menor==false){
            posEscala = this.calcPosEscalaY(dadosGrafico,yMax,maiorValor,maiorValor*0.3);
            ctx.fillText(this.formatarValor(Math.trunc(maiorValor*0.30)),53,posEscala);    
            ctx.moveTo(55, posEscala);
            ctx.lineTo(65, posEscala);
          }

          posEscala = this.calcPosEscalaY(dadosGrafico,yMax,maiorValor,maiorValor*0.5);
          ctx.fillText(this.formatarValor(Math.trunc(maiorValor*0.5)),53,posEscala);    
          ctx.moveTo(55, posEscala);
          ctx.lineTo(65, posEscala);

          if (menor==false){
            posEscala = this.calcPosEscalaY(dadosGrafico,yMax,maiorValor,maiorValor*0.7);
            ctx.fillText(this.formatarValor(Math.trunc(maiorValor*0.7)),53,posEscala);    
            ctx.moveTo(55, posEscala);
            ctx.lineTo(65, posEscala);          
          }

          posEscala = this.calcPosEscalaY(dadosGrafico,yMax,maiorValor,maiorValor*0.9);
          ctx.fillText(this.formatarValor(Math.trunc(maiorValor*0.90)),53,posEscala);    
          ctx.moveTo(55, posEscala);
          ctx.lineTo(65, posEscala);  

          //escala negativa
          if (dadosGrafico.VlSaldo<-500){

            posEscala = this.calcPosEscalaY(dadosGrafico,yMax,maiorValor,(dadosGrafico.VlSaldo)*0.90);
            ctx.fillText(this.formatarValor(Math.trunc(dadosGrafico.VlSaldo*0.90)),53,posEscala);    
            ctx.moveTo(55, posEscala);
            ctx.lineTo(65, posEscala);             
          }
        
          //eixo x
          ctx.moveTo(10, this.calcPosEscalaY(dadosGrafico,yMax,maiorValor,0));
          ctx.lineTo(xMax, this.calcPosEscalaY(dadosGrafico,yMax,maiorValor,0));

          let posEscalaReceita = 0;
          let posEscalaSaldo = 0;
          let posEscalaGastoInicio = 0;  
          let posEscalaGastoFim = 0;   
          
          posEscalaReceita = this.calcPosEscalaY(dadosGrafico,yMax,maiorValor,dadosGrafico.VlReceita);
          posEscalaSaldo = this.calcPosEscalaY(dadosGrafico,yMax,maiorValor,dadosGrafico.VlReceita-dadosGrafico.VlGastoInicio);
          posEscalaGastoInicio = this.calcPosEscalaY(dadosGrafico,yMax,maiorValor,dadosGrafico.VlGastoInicio);                   

          ctx.lineWidth = 1;
          ctx.strokeStyle = "rgb(0 0 0)";
          ctx.stroke();     
          ctx.closePath();   
          ctx.beginPath();        
          

          let posXGrafico = 0;
          if (menor==false)
            posXGrafico = (xMax*0.3)
          else
            posXGrafico = (xMax*0.5);

          ctx.font = "16px Arial";
          ctx.textAlign = "center";
          if (menor==false)
             ctx.fillText("Inicio Mês",posXGrafico+30,yMax)
          else{
                if (dadosGrafico.VlGastoFim==0)
                    ctx.fillText("Mês Aberto",posXGrafico+30,yMax)
                else
                ctx.fillText("Mês Fechado",posXGrafico+30,yMax)
          }          

          if ((menor==false)||((menor==true)&&(dadosGrafico.VlGastoFim==0))){

                ctx.rect(posXGrafico+30, posEscalaReceita, 1, (posEscalaSaldo-posEscalaReceita));                
                ctx.rect(posXGrafico, posEscalaGastoInicio, 60, 1); 

                posXGrafico = (xMax*0.7);
          }

          ctx.fillStyle = "black";
          ctx.fill();    


          ctx.lineWidth = 3;
          ctx.strokeStyle = "rgb(0 0 0)";
          ctx.stroke();    

          ctx.closePath(); 

          if (dadosGrafico.VlGastoFim>0){
            ctx.beginPath();

            posEscalaSaldo = this.calcPosEscalaY(dadosGrafico,yMax,maiorValor,dadosGrafico.VlSaldo);
            ctx.rect(posXGrafico+30, posEscalaReceita, 1, (posEscalaSaldo-posEscalaReceita));   
            ctx.lineWidth = 3;
            ctx.strokeStyle = "rgb(0 0 0)";
            ctx.stroke();       

            ctx.closePath(); 

            ctx.beginPath();    
                
            posEscalaGastoFim = this.calcPosEscalaY(dadosGrafico,yMax,maiorValor,dadosGrafico.VlGastoFim);
           // let posEscalaTamanhoGasto = this.calcPosEscalaY(dadosGrafico,yMax,maiorValor,dadosGrafico.VlGastoFim-dadosGrafico.VlGastoInicio);
           console.log(posEscalaGastoFim-posEscalaGastoInicio);
            ctx.rect(posXGrafico, posEscalaGastoFim, 60, (posEscalaGastoFim-posEscalaGastoInicio)*-1);     

            ctx.fillStyle = "green";
            ctx.fill();   

            ctx.lineWidth = 1;
            ctx.strokeStyle = "rgb(0 0 0)";
            ctx.stroke();    
            ctx.fillStyle = "black";

            ctx.font = "16px Arial";
            ctx.textAlign = "center";
            if (menor==false)            
              ctx.fillText("Durante o Mês",posXGrafico+30,yMax);    

            ctx.closePath();  
          }
      },
      formatarValor(v){
        var format = new Intl.NumberFormat('pt-BR', {minimumFractionDigits: 2});                                    
        return format.format(v);
      },
      formatarDataUrl(data){
        const dia = data.getDate().toString().padStart(2, '0');
        const mes = (data.getMonth()+1).toString().padStart(2, '0');
        const ano = data.getFullYear().toString();
        return  `${dia}${mes}${ano}`;
      },
      MudarGraficoValores(op){
        this.mostrarGraficoValores = op;
        if (op=='G')
            this.Iniciar(this.graficoMesAtual.data)

      },
      async valoresReceber(data) {
        try {
            console.log('receber');
            const hoje = new Date();
            const ano = hoje.getFullYear();
            const mes = String(hoje.getMonth() + 1).padStart(2, '0');

            const DtInicial = `${ano}-${mes}-01`;
            const lastDay = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);

            const dia = String(lastDay.getDate()).padStart(2, '0');
            const DtFinal = `${ano}-${mes}-${dia}`;   

            
            let pesquisa = {DtInicial: DtInicial, DtFinal: DtFinal, filtroTipoValor: "aberto", limitIni: 0, limitFim: 0, abafiltro:"todos"};



            //let url = `receber/listar/0/0/${this.formatarDataUrl(new Date(data))}`;
            //const response = await api.get(url); // Aguarda a resposta da API

            const response = await api.post('receber/listar',pesquisa); // Aguarda a resposta da API
            console.log(response);
            // Formata os valores recebidos
            var format = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 });
            this.ReceberValor = format.format(response.data.valor_aberto);
            this.Receberlista = response.data.qry;

        } catch (error) {
            console.log(error);
            alert('Error - listar \n' + '-' + error.response?.data || error.message);
        }
      },
      async valoresPagar(data) {
        try {
            const hoje = new Date();
            const ano = hoje.getFullYear();
            const mes = String(hoje.getMonth() + 1).padStart(2, '0');

            const DtInicial = `${ano}-${mes}-01`;
            const lastDay = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);

            const dia = String(lastDay.getDate()).padStart(2, '0');
            const DtFinal = `${ano}-${mes}-${dia}`;   

            
            let pesquisa = {DtInicial: DtInicial, DtFinal: DtFinal, filtroTipoValor: "aberto", limitIni: 0, limitFim: 0, abafiltro:"todos"};



            console.log('pagar');
            const response = await api.post('pagar/listar',pesquisa); // Aguarda a resposta da API
            console.log(response);

            // Formata os valores recebidos
            var format = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 });
            this.PagarValor = format.format(response.data.valor_aberto);
            this.Pagarlista = response.data.qry;
        } catch (error) {
            console.log(error);
            alert('Error - listar \n' + '-' + error.response?.data || error.message);
        }
      },
      async valoresCaixa() {
        try {
            let url = `caixa/listar`;
            console.log('caixa');
            const response = await api.get(url); // Aguarda a resposta da API
            this.resposta = response.data.qry;
             console.log(response);

            // Formata os valores recebidos
            var format = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 });
            this.CaixaValor = format.format(response.data.total);
            this.Caixalista = response.data.qry;
        } catch (error) {
            console.log(error);
            alert('Error - listar \n' + '-' + error.response?.data || error.message);
        }
      },    
      async valoresGrafico(data,grafico) {
        try {
            let url = `grafico/mes/${this.formatarDataUrl(new Date(data))}`;
            const response = await api.get(url); // Aguarda a resposta da API

            grafico.data = new Date(data);
            grafico.NomeMes = response.data.nome_mes;
            grafico.VlReceita = response.data.vl_receita;
            grafico.VlGastoInicio = response.data.vl_gasto_inicio;
            grafico.VlGastoFim = response.data.vl_gasto_fim;
            grafico.VlSaldo = response.data.saldo;       

        } catch (error) {
            console.log(error);
            alert('Error - listar \n' + '-' + error.response?.data || error.message);
        }
      },         
      async Iniciar(data){

            let tam = window.screen.availWidth;
            this.mostrarGraficoValores='';
            if (window.screen.availWidth<980){
                this.mostrarGraficoValores='G';
                this.tamQuadroAtual.width = window.screen.availWidth*0.75;
            }
            

            
            let dataAtual = new Date(data);    
            dataAtual.setDate(1);       
            dataAtual.setMonth(dataAtual.getMonth()); 
            console.log('dataAtual '+dataAtual);

            let dataAnterior = new Date(data);
            dataAnterior.setDate(1);    
            dataAnterior.setMonth(dataAnterior.getMonth()-1);   
            console.log('dataAnterior '+dataAnterior);   

            let dataProximo = new Date(data);
            dataProximo.setDate(1);   
            dataProximo.setMonth(dataProximo.getMonth()+1);  
            console.log('dataProximo. '+dataProximo);                   

            await this.valoresReceber(new Date(dataAnterior));
            await this.valoresPagar(new Date(dataAnterior));
            await this.valoresCaixa();

            await this.$nextTick();
            if (this.$refs.graficoAnterior) {
                await this.valoresGrafico(new Date(dataAnterior),this.graficoMesAnterior);
                await this.DesenhaGrafico(this.graficoMesAnterior,this.$refs.graficoAnterior,true);
            }
            if (this.$refs.graficoAtual) {
                await this.valoresGrafico(new Date(dataAtual),this.graficoMesAtual);            
                await this.DesenhaGrafico(this.graficoMesAtual,this.$refs.graficoAtual,false);
            }
            if (this.$refs.graficoProximo) {
                await this.valoresGrafico(new Date(dataProximo),this.graficoMesProximo);            
                await this.DesenhaGrafico(this.graficoMesProximo,this.$refs.graficoProximo,true);
            }
            



    },
    async mudarMes(mes){
        this.Iniciar(mes);
    }
  },
  mounted(){
    let dataAtual = new Date();  
    if (dataAtual.getDate()>=10)
        dataAtual.setMonth(dataAtual.getMonth()+1);
    
    this.Iniciar(dataAtual.setDate(1));
  }
}
</script>
